export function getDomainFromEmail(email: string | undefined): string {
  if (!email) {
    return '';
  }

  const indexOfAtCharacter = email.lastIndexOf('@');
  if (indexOfAtCharacter === -1) {
    return '';
  }

  return email.slice(indexOfAtCharacter + 1);
}
